document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-kit-builder-section]');

  sections.forEach(function (section) {
    const summaryList = section.querySelector('[data-kit-summary-list]');
    const subtotalEl = section.querySelector('[data-kit-subtotal]');
    const discountEl = section.querySelector('[data-kit-discount]');
    const finalTotalEl = section.querySelector('[data-kit-final-total]');
    const statusEl = section.querySelector('[data-kit-status]');
    const addBtn = section.querySelector('[data-kit-add-to-cart]');
    const resetBtn = section.querySelector('[data-kit-reset]');
    const selectedCountEl = section.querySelector('[data-kit-selected-count]');
    const recommendationEl = section.querySelector('[data-kit-recommendation]');
    const discountMeter = section.querySelector('[data-kit-discount-meter]');
    const discountMeterLabel = section.querySelector('[data-kit-discount-meter-label]');
    const discountMeterFill = section.querySelector('[data-kit-discount-meter-fill]');
    const shippingMeter = section.querySelector('[data-kit-shipping-meter]');
    const shippingMeterLabel = section.querySelector('[data-kit-shipping-meter-label]');
    const shippingMeterFill = section.querySelector('[data-kit-shipping-meter-fill]');

    function formatCurrency(value) {
      var currency = section.dataset.shopCurrency || 'USD';
      try {
        return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(value);
      } catch (e) {
        return (currency ? currency + ' ' : '') + value.toFixed(2);
      }
    }

    function setupProductDetails() {
      const cards = section.querySelectorAll('[data-kit-product-card]');
      if (!cards.length) return;

      const modal = document.createElement('div');
      modal.className = 'kit-builder__details-modal';
      modal.hidden = true;
      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute('aria-labelledby', 'kit-builder-details-title');
      modal.innerHTML = '<div class="kit-builder__details-backdrop" data-kit-details-close></div>' +
        '<div class="kit-builder__details-dialog" role="document">' +
        '<button type="button" class="kit-builder__details-close" data-kit-details-close aria-label="Close product details">×</button>' +
        '<div class="kit-builder__details-content"></div>' +
        '</div>';
      section.appendChild(modal);

      const content = modal.querySelector('.kit-builder__details-content');
      let lastTrigger = null;

      function closeModal() {
        modal.hidden = true;
        document.body.classList.remove('kit-builder-modal-open');
        if (lastTrigger) lastTrigger.focus();
      }

      function openModal(card, trigger) {
        const title = card.querySelector('.kit-builder__product-top h4');
        const type = card.querySelector('.kit-builder__product-type');
        const description = card.querySelector('.kit-builder__product-desc');
        const image = card.querySelector('.kit-builder__product-image img');
        const price = card.querySelector('[data-kit-price]');
        const variant = card.querySelector('[data-kit-variant-select]');

        content.innerHTML = '';
        if (image) {
          const modalImage = image.cloneNode(true);
          modalImage.className = 'kit-builder__details-image';
          modalImage.loading = 'eager';
          content.appendChild(modalImage);
        }

        const heading = document.createElement('h3');
        heading.id = 'kit-builder-details-title';
        heading.textContent = title ? title.textContent : 'Product details';
        content.appendChild(heading);

        if (type && type.textContent.trim()) {
          const typeText = document.createElement('p');
          typeText.className = 'kit-builder__details-type';
          typeText.textContent = type.textContent;
          content.appendChild(typeText);
        }

        if (description && description.textContent.trim()) {
          const descriptionText = document.createElement('p');
          descriptionText.className = 'kit-builder__details-description';
          descriptionText.textContent = description.textContent;
          content.appendChild(descriptionText);
        } else {
          const fallback = document.createElement('p');
          fallback.className = 'kit-builder__details-description';
          fallback.textContent = 'Choose this product to add it to your kit.';
          content.appendChild(fallback);
        }

        if (price) {
          const priceText = document.createElement('strong');
          priceText.className = 'kit-builder__details-price';
          priceText.textContent = price.textContent;
          content.appendChild(priceText);
        }

        if (variant) {
          const variantLabel = document.createElement('p');
          variantLabel.className = 'kit-builder__details-variant';
          variantLabel.textContent = 'Available in multiple variants.';
          content.appendChild(variantLabel);
        }

        lastTrigger = trigger;
        modal.hidden = false;
        document.body.classList.add('kit-builder-modal-open');
        modal.querySelector('[data-kit-details-close]').focus();
      }

      modal.querySelectorAll('[data-kit-details-close]').forEach(function (closeButton) {
        closeButton.addEventListener('click', closeModal);
      });

      document.addEventListener('keydown', function (event) {
        if (!modal.hidden && event.key === 'Escape') closeModal();
      });

      cards.forEach(function (card) {
        const controls = card.querySelector('[data-kit-qty-controls], .kit-builder__radio-row');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kit-builder__details-btn';
        button.textContent = 'View details';
        button.addEventListener('click', function () { openModal(card, button); });
        (controls || card).appendChild(button);
      });
    }

    function getSelectedItems(group) {
      const items = [];
      const scope = group || section;

      scope.querySelectorAll('[data-kit-qty-input]').forEach(function (input) {
        const quantity = parseInt(input.value || '0', 10);
        if (quantity > 0) {
          const card = input.closest('[data-kit-product-card]');
          const price = Number(input.dataset.price || card?.dataset.defaultPrice || 0);
          const image = card?.querySelector('.kit-builder__product-image img');
          items.push({
            id: Number(input.dataset.variantId || card?.dataset.defaultVariantId || 0),
            quantity: quantity,
            title: card?.dataset.productTitle || 'Product',
            price: price,
            image: image?.currentSrc || image?.src || ''
          });
        }
      });

      scope.querySelectorAll('[data-kit-radio]:checked').forEach(function (radio) {
        const card = radio.closest('[data-kit-product-card]');
        const price = Number(radio.dataset.price || card?.dataset.defaultPrice || 0);
        const image = card?.querySelector('.kit-builder__product-image img');
        items.push({
          id: Number(radio.dataset.variantId || card?.dataset.defaultVariantId || 0),
          quantity: 1,
          title: card?.dataset.productTitle || 'Product',
          price: price,
          image: image?.currentSrc || image?.src || ''
        });
      });

      return items;
    }

    function getSelectionState() {
      let subtotal = 0;
      let discountAmount = 0;
      let hasMinimumError = false;

      section.querySelectorAll('[data-kit-group]').forEach(function (group) {
        const groupItems = getSelectedItems(group);
        const groupSubtotal = groupItems.reduce(function (sum, item) {
          return sum + (Number(item.price || 0) * item.quantity);
        }, 0);
        subtotal += groupSubtotal;

        const totalQty = groupItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        const requiredMin = Number(group.dataset.minSelectedQty || 0);
        const minQty = Number(group.dataset.discountMin || 0);
        const pct = Number(group.dataset.discountPercent || 0);

        if (requiredMin > 0 && totalQty < requiredMin) {
          hasMinimumError = true;
        }

        if (totalQty >= minQty && pct > 0) {
          discountAmount += groupSubtotal * (pct / 100);
        }

      });

      return { subtotal, discountAmount, hasMinimumError };
    }

    function setAddingState(isAdding) {
      if (!addBtn) return;
      addBtn.disabled = isAdding;
      addBtn.textContent = isAdding ? 'Adding…' : (addBtn.dataset.originalLabel || 'Add Kit to Cart');
    }

    function refreshCartUi() {
      const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';

      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : Promise.reject(new Error('Failed to refresh cart'));
        })
        .then(function (cart) {
          document.querySelectorAll('[data-cart-count], [data-cart-count-bubble], .cart-count-bubble span').forEach(function (countEl) {
            countEl.textContent = cart.item_count;
          });

          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));

          const drawer = document.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer');
          if (!drawer) return cart;

          const sectionWrapper = drawer.closest('[id^="shopify-section-"]');
          const sectionId = sectionWrapper
            ? sectionWrapper.id.replace('shopify-section-', '')
            : drawer.id;

          if (!sectionId) {
            if (typeof drawer.open === 'function') drawer.open();
            return cart;
          }

          return fetch(root + 'cart?section_id=' + encodeURIComponent(sectionId), {
            headers: { Accept: 'text/html' }
          })
            .then(function (response) {
              return response.ok ? response.text() : Promise.reject(new Error('Failed to refresh cart drawer'));
            })
            .then(function (html) {
              const template = document.createElement('template');
              template.innerHTML = html;
              const updatedDrawer = template.content.querySelector('cart-drawer, [data-cart-drawer], .cart-drawer');

              if (updatedDrawer) {
                drawer.replaceWith(updatedDrawer);
                if (typeof updatedDrawer.open === 'function') updatedDrawer.open();
              } else if (typeof drawer.open === 'function') {
                drawer.open();
              }

              return cart;
            })
            .catch(function () {
              if (typeof drawer.open === 'function') drawer.open();
              return cart;
            });
        });
    }

    function updateSummary() {
      if (!summaryList || !subtotalEl || !discountEl || !finalTotalEl) {
        return;
      }

      const selectedItems = getSelectedItems(section);
      summaryList.innerHTML = '';

      if (!selectedItems.length) {
        const emptyItem = document.createElement('li');
        emptyItem.className = 'kit-builder__summary-empty';
        emptyItem.textContent = 'Your selected products will appear here.';
        summaryList.appendChild(emptyItem);
      }

      let subtotal = 0;
      let discountAmount = 0;
      let hasMinimumError = false;
      let nextDiscount = null;

      section.querySelectorAll('[data-kit-group]').forEach(function (group) {
        const groupItems = getSelectedItems(group);
        const groupSubtotal = groupItems.reduce(function (sum, item) {
          return sum + (Number(item.price || 0) * item.quantity);
        }, 0);
        subtotal += groupSubtotal;

        groupItems.forEach(function (item) {
          const line = Number(item.price || 0) * item.quantity;
          const li = document.createElement('li');
          li.className = 'kit-builder__summary-item';

          if (item.image) {
            const image = document.createElement('img');
            image.className = 'kit-builder__summary-image';
            image.src = item.image;
            image.alt = item.title;
            image.loading = 'lazy';
            li.appendChild(image);
          }

          const details = document.createElement('div');
          details.className = 'kit-builder__summary-details';

          const title = document.createElement('span');
          title.className = 'kit-builder__summary-title';
          title.textContent = item.title;
          details.appendChild(title);

          const quantity = document.createElement('span');
          quantity.className = 'kit-builder__summary-quantity';
          quantity.textContent = 'Qty ' + item.quantity;
          details.appendChild(quantity);

          const price = document.createElement('strong');
          price.className = 'kit-builder__summary-price';
          price.textContent = formatCurrency(line);

          li.appendChild(details);
          li.appendChild(price);
          summaryList.appendChild(li);
        });

        const totalQty = groupItems.reduce(function (sum, item) { return sum + item.quantity; }, 0);
        const requiredMin = Number(group.dataset.minSelectedQty || 0);
        const minQty = Number(group.dataset.discountMin || 0);
        const pct = Number(group.dataset.discountPercent || 0);
        const promptEl = group.querySelector('[data-kit-discount-prompt]');

        if (requiredMin > 0 && totalQty < requiredMin) {
          hasMinimumError = true;
        }

        if (promptEl && minQty > 0) {
          const remaining = Math.max(0, minQty - totalQty);
          promptEl.textContent = remaining > 0
            ? 'Add ' + remaining + ' more product' + (remaining === 1 ? '' : 's') + ' to get ' + pct + '% discount.'
            : 'You are eligible for the ' + pct + '% discount in this collection.';
        }

        if (totalQty >= minQty && pct > 0) {
          discountAmount += groupSubtotal * (pct / 100);
        }

        if (pct > 0 && minQty > 0 && totalQty < minQty) {
          const remaining = minQty - totalQty;
          if (!nextDiscount || remaining < nextDiscount.remaining) {
            nextDiscount = { remaining: remaining, minQty: minQty, pct: pct };
          }
        }
      });

      const finalTotal = subtotal - discountAmount;

      if (discountMeter && discountMeterLabel && discountMeterFill) {
        const discountProgress = nextDiscount
          ? Math.min(100, ((nextDiscount.minQty - nextDiscount.remaining) / nextDiscount.minQty) * 100)
          : 100;
        discountMeterLabel.textContent = nextDiscount
          ? 'Add ' + nextDiscount.remaining + ' more to save ' + nextDiscount.pct + '%.'
          : 'All bundle savings unlocked.';
        discountMeterFill.style.width = discountProgress + '%';
        discountMeter.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(discountProgress)));
      }

      if (shippingMeter && shippingMeterLabel && shippingMeterFill) {
        const shippingThreshold = Number(shippingMeter.dataset.shippingThreshold || 0);
        const shippingRemaining = Math.max(0, shippingThreshold - finalTotal);
        const shippingProgress = shippingThreshold > 0 ? Math.min(100, (finalTotal / shippingThreshold) * 100) : 0;
        shippingMeterLabel.textContent = shippingRemaining > 0
          ? 'Spend ' + formatCurrency(shippingRemaining) + ' more.'
          : 'You qualify for free shipping.';
        shippingMeterFill.style.width = shippingProgress + '%';
        shippingMeter.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', String(Math.round(shippingProgress)));
      }

      subtotalEl.textContent = formatCurrency(subtotal);
      discountEl.textContent = '-' + formatCurrency(discountAmount);
      finalTotalEl.textContent = formatCurrency(finalTotal);

      if (selectedCountEl) {
        selectedCountEl.textContent = selectedItems.length + ' selected';
      }

      if (recommendationEl) {
        const hasDiscount = discountAmount > 0;
        recommendationEl.textContent = hasDiscount
          ? 'You save ' + formatCurrency(discountAmount) + ' on this bundle.'
          : 'Add more products to unlock a bundle discount.';
        recommendationEl.classList.toggle('kit-builder__recommendation--ready', hasDiscount);
      }

      if (statusEl) {
        if (hasMinimumError) {
          statusEl.textContent = 'Select at least the minimum number of products required in each collection.';
        } else if (selectedItems.length) {
          statusEl.textContent = 'Ready to add ' + selectedItems.length + ' item(s) to cart.';
        } else {
          statusEl.textContent = 'Select at least one product to continue.';
        }
      }
    }

    setupProductDetails();

    function handleQuantityChange(input, delta) {
      const currentValue = parseInt(input.value || '0', 10);
      const nextValue = Math.max(0, currentValue + delta);
      input.value = nextValue;
      updateSummary();
    }

    section.querySelectorAll('[data-kit-increase]').forEach(function (button) {
      button.addEventListener('click', function () {
        const input = button.closest('[data-kit-product-card]')?.querySelector('[data-kit-qty-input]');
        if (input) handleQuantityChange(input, 1);
      });
    });

    section.querySelectorAll('[data-kit-decrease]').forEach(function (button) {
      button.addEventListener('click', function () {
        const input = button.closest('[data-kit-product-card]')?.querySelector('[data-kit-qty-input]');
        if (input) handleQuantityChange(input, -1);
      });
    });

    section.querySelectorAll('[data-kit-qty-input]').forEach(function (input) {
      input.addEventListener('input', function () {
        const value = Math.max(0, parseInt(input.value || '0', 10) || 0);
        input.value = value;
        updateSummary();
      });
    });

    section.querySelectorAll('[data-kit-radio]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        const group = radio.closest('[data-kit-group]');
        if (!group || group.dataset.selectionType !== 'single') return;
        group.querySelectorAll('[data-kit-radio]').forEach(function (other) {
          if (other !== radio) other.checked = false;
        });
        updateSummary();
      });
    });

    section.querySelectorAll('[data-kit-variant-select]').forEach(function (select) {
      select.addEventListener('change', function () {
        const selectedOption = select.options[select.selectedIndex];
        const card = select.closest('[data-kit-product-card]');
        const priceEl = card.querySelector('[data-kit-price]');
        const qtyInput = card.querySelector('[data-kit-qty-input]');
        const radio = card.querySelector('[data-kit-radio]');

        if (priceEl) {
          priceEl.textContent = formatCurrency(Number(selectedOption.dataset.variantPrice || 0));
        }

        if (qtyInput) {
          qtyInput.dataset.variantId = selectedOption.dataset.variantId;
          qtyInput.dataset.price = selectedOption.dataset.variantPrice;
        }
        if (radio) {
          radio.dataset.variantId = selectedOption.dataset.variantId;
          radio.dataset.price = selectedOption.dataset.variantPrice;
        }

        const controls = card.querySelectorAll('[data-kit-increase], [data-kit-decrease], [data-kit-qty-input]');
        controls.forEach(function (control) {
          control.dataset.variantId = selectedOption.dataset.variantId;
          control.dataset.price = selectedOption.dataset.variantPrice;
        });

        updateSummary();
      });
    });

    if (resetBtn) {
      resetBtn.addEventListener('click', function () {
        section.querySelectorAll('[data-kit-qty-input]').forEach(function (input) { input.value = 0; });
        section.querySelectorAll('[data-kit-radio]').forEach(function (radio) { radio.checked = false; });
        updateSummary();
      });
    }

    if (addBtn) {
      addBtn.dataset.originalLabel = addBtn.textContent.trim();

      addBtn.addEventListener('click', function () {
      const items = getSelectedItems(section).map(function (item) {
        return { id: item.id, quantity: item.quantity };
      });
      const selectionState = getSelectionState();

      if (!items.length) {
        if (statusEl) statusEl.textContent = 'Select at least one product first.';
        return;
      }

      if (selectionState.hasMinimumError) {
        if (statusEl) statusEl.textContent = 'Select at least the minimum number of products required in each collection.';
        return;
      }

      setAddingState(true);
      if (statusEl) statusEl.textContent = 'Adding your kit to the cart…';

      const cartUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart/add.js';

      fetch(cartUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (response) { return response.ok ? response.json() : Promise.reject(new Error('Failed to add to cart')); })
        .then(function () {
          return refreshCartUi();
        })
        .then(function () {
          if (statusEl) statusEl.textContent = 'Kit added to cart.';
        })
        .catch(function () {
          if (statusEl) {
            statusEl.textContent = 'Unable to add kit to cart right now.';
          }
        })
        .finally(function () {
          setAddingState(false);
        });
      });
    }

    updateSummary();
  });
});
